import { Component } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { Router } from '@angular/router'; // Importez le service Router*
import { roleService } from 'src/app/services/role.service';
import { SideNavInterface } from '../../interfaces/side-nav.type';
import { AuthService } from 'src/app/services/auth.service';   // -saml changes-
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent {
  public menuItems: any[];
  isFolded: boolean;
  isSideNavDark: boolean;
  isExpand: boolean;
  rtl = document.documentElement.dir === 'rtl'; // -arabic- pose par main.ts (la page se recharge quand le sens change)
  user: any;
  pairs: any[] = [];   // -sidebar- [{etablissementNom, roleName}] : "etab / role", un par ligne



  constructor(private themeService: ThemeConstantService, private router: Router, private roleService: roleService,
              private authService: AuthService, private http: HttpClient) { } // -saml changes- authService pour le logout Keycloak

  ngOnInit(): void {
    // -sidebar- paires etab/role (sans ADMIN/PARTNER_CLIENT) ; vide -> ancien affichage
    this.http.get<any[]>(`${environment.apiUrl}/profil/pairs`,
      { headers: new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` }) })
      .subscribe({
        // ADMIN/PARTNER_CLIENT jamais en paire ; etab sans role garde (affiche "ENIT" seul)
        next: d => this.pairs = (d || []).filter(p => !this.isTech(p.roleName)),
        error: () => this.pairs = []
      });
    const isAdmin = this.roleService.isAdmin();
    const userString = localStorage.getItem('user');
    if (userString) {
      this.user = JSON.parse(userString);

      console.log('Utilisateur récupéré depuis localStorage :', this.user);
    }

      // Appel de votre méthode personnalisée
      this.menuItems = ROUTES
        .filter(menuItem => !menuItem.role || (menuItem.role === 'ADMIN' && isAdmin))
        .map(menuItem => {
          // Si ce n'est pas admin et que titleForNonAdmin est défini, on remplace le titre
          if (!isAdmin && menuItem.titleForNonAdmin) {
            return {
              ...menuItem,
              title: menuItem.titleForNonAdmin
            };
          }
          return menuItem;
        });


    const indexInsertion = 2;
    if (this.user?.etablissements?.length) {
      const etablissementsMenu = {
        title: 'menu.myEtabs',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'appstore',
        submenu: this.user.etablissements.map((etab: any) => ({
          path: `${etab.url}`,  // ou autre URL selon ton routing
          title: etab.nom,
          iconType: 'nzIcon',
          iconTheme: 'outline',
          icon: 'global',
          submenu: [],
          external: true

        }))
      };
           this.menuItems.splice(indexInsertion, 0, etablissementsMenu);
    }

      // Ajouter dynamiquement le menu à la fin
 
   
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);

  }

  isTech(name: any): boolean {
    return ['ADMIN', 'PARTNER_CLIENT'].includes(String(name || '').trim().toUpperCase());
  }

  /** -sidebar- rôles techniques (ADMIN) affichés au-dessus des paires. */
  get techRoles(): string[] {
    return (this.user?.roles || []).map((r: any) => r?.name?.trim()).filter((n: string) => this.isTech(n));
  }

  closeMobileMenu(): void {
    if (window.innerWidth < 992) {
      this.isFolded = false;
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
      this.themeService.toggleFold(this.isFolded);
    }
  }

  navigate(item: any): void {
    if (item.external) {
      // Ici on considère que path est une URL complète (ex: https://google.com)
      let url = item.path;
      // Garde-fou: si l'URL est absente/invalide, ne pas ouvrir une URL relative
      // cassée (qui redirigeait vers la page 404 error-1).
      if (!url || url === 'undefined' || url === 'null') {
        console.warn('URL externe manquante pour l’établissement :', item);
        return;
      }
      // Ajoute le schéma si absent pour éviter une ouverture en URL relative.
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url;
      }
      window.open(url, '_blank');
      return;
    }
       if (item.action === 'logout') {
      this.logout();  // Appeler la méthode logout si l'action est 'logout'
    }
    if (!item.path) {
      console.warn('Path vide ou invalide pour le menu :', item);
      return;
    }
  else {
      this.router.navigate([item.path]); // Utilisez le service Router pour naviguer
      this.closeMobileMenu();
    }
  }

  // -saml changes- Déléguer au service (voir header.component.ts) : lui seul
  // ferme aussi la session Keycloak.
  logout() {
    this.authService.logout();
  }
}
